import { Link } from "react-router-dom";
import { WerkoWordmark } from "@/components/WerkoWordmark";

// Turn Light Mode — hex hardcodés remplacés par tokens Tailwind qui basculent
// automatiquement selon `<html class="dark|light">`.
export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-platform-bg px-4 py-10">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="mb-6 flex justify-center"
          data-testid="brand-link"
        >
          <WerkoWordmark size="md" />
        </Link>
        <div className="rounded-2xl border border-platform-border bg-platform-surface p-7 backdrop-blur">
          <h1 className="text-2xl font-bold text-platform-heading">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-platform-body">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </div>
        {footer && <div className="mt-6 text-center text-sm text-platform-body">{footer}</div>}
        <div className="mt-8 flex justify-center gap-4 text-[11px] text-platform-muted">
          <Link to="/legal/mentions" className="hover:text-platform-body">
            Mentions
          </Link>
          <Link to="/legal/privacy" className="hover:text-platform-body">
            Confidentialité
          </Link>
          <Link to="/legal/terms" className="hover:text-platform-body">
            CGU
          </Link>
        </div>
      </div>
    </div>
  );
}
